import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { useLanguage } from "../i18n/LanguageContext";
import { SOCIAL } from "../data/social";
import { antesDoFim1aEdicao } from "../data/datas";

// Colunas alinhadas com o menu principal: Noite de Fados · Artistas · A Associação · Bilhetes · Contacto
const COL_IDS = ["noite-fados", "artistas", "associacao", "bilhetes", "contacto"];

export const Footer = () => {
    const { t } = useLanguage();
    return (
        <footer className="bg-[#070503]" data-testid="main-footer">
            <div className="mx-auto max-w-[1500px] px-5 sm:px-10 py-14">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-4">
                        <button onClick={() => scrollToId("#topo")} data-testid="footer-logo" aria-label="Fados à Mesa — voltar ao topo">
                            <img src="/images/logo.webp" alt="Fados à Mesa — 1ª Edição" className="h-16 w-auto" width="1295" height="388" />
                        </button>
                        <p className="font-display italic font-light text-[#efe6d6]/50 text-base mt-5" data-testid="footer-phrase">
                            {t.footer.frase}
                        </p>
                    </div>
                    <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-[repeat(5,minmax(0,1fr))] gap-8">
                        {t.footer.colunas.map((col, ci) => (
                            <div key={COL_IDS[ci]} className="min-w-0">
                                <h3 className="font-caps text-xs tracking-[0.22em] uppercase text-[#c9a24b] break-words" data-testid={`footer-col-${COL_IDS[ci]}`}>
                                    {col.title}
                                </h3>
                                <ul className="mt-4 space-y-2.5">
                                    {col.links.filter((l) => !l.ate1aEdicao || antesDoFim1aEdicao()).map((l, li) => (
                                        <li key={li}>
                                            {l.to.startsWith("/#") ? (
                                                <a
                                                    href={l.to}
                                                    data-testid={`footer-link-${COL_IDS[ci]}-${li}`}
                                                    className="text-sm font-light text-[#efe6d6]/60 hover:text-[#c9a24b] transition-colors duration-300"
                                                >
                                                    {l.label}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={l.to}
                                                    data-testid={`footer-link-${COL_IDS[ci]}-${li}`}
                                                    className="text-sm font-light text-[#efe6d6]/60 hover:text-[#c9a24b] transition-colors duration-300"
                                                >
                                                    {l.label}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                {COL_IDS[ci] === "contacto" && (
                                    <div className="flex gap-4 mt-5">
                                        <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="text-[#c9a24b]/60 hover:text-[#c9a24b] transition-colors duration-300" data-testid="footer-instagram" aria-label="Instagram oficial do Fados à Mesa">
                                            <Instagram size={20} strokeWidth={1.4} />
                                        </a>
                                        <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" className="text-[#c9a24b]/60 hover:text-[#c9a24b] transition-colors duration-300" data-testid="footer-facebook" aria-label="Facebook oficial do Fados à Mesa">
                                            <Facebook size={20} strokeWidth={1.4} />
                                        </a>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-[#c9a24b]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-[11px] text-[#efe6d6]/50 font-light text-center sm:text-left mb-2" data-testid="footer-sede">{t.footer.sede}</p>
                    <p className="text-xs text-[#efe6d6]/40 font-light text-center sm:text-left">{t.footer.copyright}</p>
                    <div className="flex flex-wrap justify-center sm:justify-end gap-x-8 gap-y-2">
                        <Link
                            to="/privacidade"
                            className="font-caps text-[10px] tracking-[0.2em] uppercase text-[#efe6d6]/40 hover:text-[#c9a24b] transition-colors duration-300"
                            data-testid="footer-privacy"
                        >
                            {t.footer.privacy}
                        </Link>
                        <Link
                            to="/termos"
                            className="font-caps text-[10px] tracking-[0.2em] uppercase text-[#efe6d6]/40 hover:text-[#c9a24b] transition-colors duration-300"
                            data-testid="footer-terms"
                        >
                            {t.footer.terms}
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};
